import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { AntButtonModule } from '@antony/ng-ui';
import { TranslatePipe } from '@ngx-translate/core';

export interface SimpleDialogConfig {
  title: string;
  message: string;
  submitActionName?: string;
  dismissActionName?: string;
}

@Component({
  selector: 'app-simple-dialog',
  templateUrl: './simple-dialog.component.html',
  styleUrls: ['./simple-dialog.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, AntButtonModule, TranslatePipe],
})
export class SimpleDialogComponent {
  public readonly data: Required<SimpleDialogConfig>;

  constructor(
    private matDialogRef: MatDialogRef<SimpleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: SimpleDialogConfig
  ) {
    this.data = {
      dismissActionName: 'NO',
      submitActionName: 'YES',
      ...data,
    };
  }

  dismiss() {
    this.matDialogRef.close(false);
  }

  submit() {
    this.matDialogRef.close(true);
  }
}
